import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import { Modal } from "app/components/Modal";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectAddOnTyingStripModal } from "../../../redux/selector";
import { actions } from "../../../redux/slice";
import { ADD_ON_TABLE_COLUMN_LABELS } from "../data";
import { useStyles } from "./styles";

const AddTyingStripModal = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const modal = useSelector(selectAddOnTyingStripModal);

  if (!modal?.open) {
    return null;
  }

  const patch = (field: "height" | "note", value: string) =>
    dispatch(actions.updateAddOnTyingStripModalField({ field, value }));

  const canSubmit = modal.height.trim().length > 0;

  return (
    <Modal open={modal.open} onClose={() => dispatch(actions.closeAddOnTyingStripModal())}>
      <Box className={styles.tyingStripModal}>
        <Box className={styles.tyingStripModalHeader}>
          <Typography className={styles.tyingStripModalTitle}>{t(modal.titleKey)}</Typography>
          <IconButton
            className={styles.tyingStripModalClose}
            onClick={() => dispatch(actions.closeAddOnTyingStripModal())}
            aria-label={t("BUTTONS.CANCEL")}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className={styles.tyingStripModalBody}>
          <Box className={styles.tyingStripModalField}>
            <Typography className={styles.tyingStripModalLabel}>
              {t(ADD_ON_TABLE_COLUMN_LABELS.height)}
            </Typography>
            <TextField
              className={styles.tyingStripModalInput}
              fullWidth
              variant="outlined"
              placeholder={t(ADD_ON_TABLE_COLUMN_LABELS.height)}
              value={modal.height}
              InputProps={{ notched: false }}
              onChange={(e) => patch("height", e.target.value)}
            />
          </Box>
          <Box className={styles.tyingStripModalField}>
            <Typography className={styles.tyingStripModalLabel}>
              {t(ADD_ON_TABLE_COLUMN_LABELS.note)}
            </Typography>
            <TextField
              className={styles.tyingStripModalInput}
              fullWidth
              variant="outlined"
              placeholder={t(ADD_ON_TABLE_COLUMN_LABELS.note)}
              value={modal.note}
              InputProps={{ notched: false }}
              onChange={(e) => patch("note", e.target.value)}
            />
          </Box>
        </Box>

        <Box className={styles.tyingStripModalFooter}>
          <Button
            className={styles.tyingStripModalCancelBtn}
            variant="outlined"
            onClick={() => dispatch(actions.closeAddOnTyingStripModal())}
          >
            {t("BUTTONS.CANCEL")}
          </Button>
          <Button
            className={styles.tyingStripModalAddBtn}
            variant="contained"
            disableElevation
            disabled={!canSubmit}
            onClick={() => dispatch(actions.submitAddOnTyingStripModal())}
          >
            {t("BUTTONS.ADD")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddTyingStripModal;
